/**
 * @fileoverview Context for the JSONForm component
 *
 * @example
 * // Usage:
 * import { JSONFormContext } from './JSONFormContext'
 *
 * function Component() {
 *   // ...
 * }
 */

import { createContext } from 'react'

/**
 * @interface JSONFormContextPayload
 * @description The payload for the JSONFormContext
 * @property {() => void} clearErrors - The function to clear the errors
 * @property {(data: Record<string, unknown>) => void} onSubmit - The function to submit the form
 */
export interface JSONFormContextPayload {
    clearErrors: () => void
    onSubmit: (data: Record<string, unknown>) => void
}

export const JSONFormContext = createContext<JSONFormContextPayload>(undefined)
